/* Elora video loader — pairs with snippets/elora-video.liquid.
   1. A video gets its poster and mp4 source only when it comes within one viewport (nothing downloads for clips
      the visitor never reaches).
   2. Videos marked data-autoplay play while on screen and pause off-screen or when the tab is hidden.
      Under prefers-reduced-motion they show their poster and never start.
   Sections with their own play logic (elora-video-steps) call window.Elora.attachVideo(video) before play().
   3. A video marked data-on-demand (snippet param on_demand: true) is never observed here: nothing — not even the
      poster — is fetched until its section sets src/poster itself on a tap (elora-video-reviews: clips with sound). */
window.Elora = window.Elora || {};

(function () {
  var NS = window.Elora;
  if (NS.attachVideo) return;
  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function poster(v) {
    if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster;
  }

  function attach(v) {
    if (v.dataset.attached === '1') return;
    v.dataset.attached = '1';
    poster(v);
    if (v.dataset.src) {
      v.src = v.dataset.src;
      v.load();
    }
  }
  NS.attachVideo = attach;

  function play(v) {
    attach(v);
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && p.catch) p.catch(function () {});
  }

  function sync(v) {
    if (still || v.dataset.userPaused === '1') return; /* a visitor's pause (gallery button) wins over autoplay */
    if (v.dataset.onScreen === '1' && !document.hidden) {
      if (v.paused) play(v);
    } else if (!v.paused) {
      v.pause();
    }
  }

  function init(scope) {
    var vids = [].slice.call((scope || document).querySelectorAll('video[data-src]:not([data-bound]):not([data-on-demand])'));
    if (!vids.length) return;
    vids.forEach(function (v) { v.dataset.bound = '1'; v.muted = true; v.defaultMuted = true; });
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { if (still) poster(v); else { attach(v); if (v.hasAttribute('data-autoplay')) play(v); } });
      return;
    }
    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { if (still && e.target.hasAttribute('data-autoplay')) poster(e.target); else attach(e.target); near.unobserve(e.target); } });
    }, { rootMargin: '100% 0px' });
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.dataset.onScreen = e.isIntersecting ? '1' : '0'; sync(e.target); });
    }, { threshold: 0.2 });
    vids.forEach(function (v) {
      near.observe(v);
      if (v.hasAttribute('data-autoplay')) seen.observe(v);
    });
  }

  document.addEventListener('visibilitychange', function () {
    [].slice.call(document.querySelectorAll('video[data-autoplay][data-bound]')).forEach(sync);
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
